// catalog_search_enter.js
// Custom app: raftor_webhq
// Behavior:
// 1) On Enter in #search-box, update URL ?search=<value> and reset start.
// 2) Patch webshop.ProductView.get_query_filters to pass search into backend
//    query_args, without touching core files.

(function() {
    'use strict';
	var isAllProductsPage = window.location && window.location.pathname === "/all-products";
	var isItemGroupListing = Boolean(document.querySelector('.item-group-content[data-item-group]'));
	var hasListingRoot = Boolean(document.getElementById('product-listing'));
	if (!isAllProductsPage && !isItemGroupListing && !hasListingRoot) {
		return;
	}

    var initAttempts = 0;
    var maxInitAttempts = 40;

    function init() {
        initAttempts++;
        if (typeof frappe === 'undefined' || typeof window.webshop === 'undefined' || !window.webshop.ProductView) {
            // Wait until core JS is loaded, but stop retrying after a bounded window.
            if (initAttempts < maxInitAttempts) {
                setTimeout(init, 100);
            }
            return;
        }

        patchProductView();
        bindEnterKey();
        installDiscountFilterStabilizer();
    }

    function patchProductView() {
        var ProductView = window.webshop && window.webshop.ProductView;
        if (!ProductView || !ProductView.prototype) return;

        var proto = ProductView.prototype;
        if (proto.__catalog_search_patched) {
            return;
        }

        var originalGetQueryFilters = proto.get_query_filters;
        proto.get_query_filters = function() {
            // Call original implementation to keep native behavior
            var args = originalGetQueryFilters
                ? originalGetQueryFilters.call(this)
                : {};

            try {
                var qp = frappe.utils.get_query_params();
                if (qp && qp.search) {
                    args.search = qp.search;
                }
            } catch (e) {
                // Fail-safe: don't break listing if something goes wrong
            }

            return args;
        };

        // Expose current ProductView instance for custom extensions.
        // This avoids hard reloads and lets us re-use native `make(true)` refresh.
        var originalMake = proto.make;
        if (typeof originalMake === 'function') {
            proto.make = function(from_filters) {
                try {
                    window.__raftorProductView = this;
                } catch (e) {
                    // no-op
                }
                var out = originalMake.call(this, from_filters);
                try {
                    setTimeout(installDiscountFilterStabilizer, 0);
                } catch (e) {
                    // no-op
                }
                return out;
            };
        }

        // Core's add_paging_section disables Next via `product_count > page_length`,
        // written for "remaining rows" count semantics. Our API returns the full
        // total, so recompute both buttons from (start, page_length, total) —
        // correct for any catalog size, including the exact last page.
        var originalAddPaging = proto.add_paging_section;
        if (typeof originalAddPaging === 'function') {
            proto.add_paging_section = function(settings) {
                var out = originalAddPaging.call(this, settings);
                try {
                    var pageLength = Number(settings && settings.products_per_page) || 0;
                    var totalCount = Number(this.product_count) || 0;
                    var start = 0;
                    var qp = frappe.utils.get_query_params();
                    if (qp && qp.start) {
                        start = Number(JSON.parse(qp.start)) || 0;
                    }
                    if (pageLength > 0) {
                        var nextBtn = document.querySelector('.btn-next');
                        var prevBtn = document.querySelector('.btn-prev');
                        if (nextBtn) {
                            nextBtn.disabled = start + pageLength >= totalCount;
                        }
                        if (prevBtn) {
                            prevBtn.disabled = start <= 0;
                        }
                    }
                } catch (e) {
                    // Fail-safe: never break the listing over paging cosmetics
                }
                return out;
            };
        }

        proto.__catalog_search_patched = true;
    }

    function bindEnterKey() {
        if (document.__catalog_search_global_bound) return;
        document.__catalog_search_global_bound = true;

        document.addEventListener('keydown', function(e) {
            var target = e.target || e.srcElement;
            if (!target || !target.id || target.id !== 'search-box') {
                return;
            }

            if (e.key === 'Enter') {
                e.preventDefault();
                var query = (target.value || '').trim();
                var url = new URL(window.location.href);

                if (query) {
                    url.searchParams.set('search', query);
                } else {
                    url.searchParams.delete('search');
                }

                // Reset pagination when a new search is triggered
                url.searchParams.delete('start');

                window.location.href = url.toString();
            }
        }, true);
    }

    // Discount filter UI stabilization:
    // Keep discount filter block stable after listing refreshes without monkey-patching
    // ProductView renderer methods.
    function installDiscountFilterStabilizer() {
        function stabilizeDiscountFilterBlock() {
            var filtersRoot = document.getElementById('product-filters');
            if (!filtersRoot) return;

            var block = document.getElementById('discount-filters');
            var options = block && block.querySelector('.filter-options');
            if (!block || !options) return;

            // Core aligns: discount is appended to #product-filters, so keep it at the bottom.
            if (block.parentNode === filtersRoot) {
                if (filtersRoot.lastElementChild !== block) {
                    filtersRoot.appendChild(block);
                }
            } else {
                filtersRoot.appendChild(block);
            }

            restoreDiscountSelection(block);
        }

        function restoreDiscountSelection(block) {
            if (!block) return;
            try {
                var filters = frappe.utils.get_query_params();
                var fieldFilters = filters.field_filters ? JSON.parse(filters.field_filters) : {};
                var values = fieldFilters && fieldFilters.discount;
                if (!Array.isArray(values)) return;

                values.forEach(function(value) {
                    var selector = 'input[data-filter-name="discount"][data-filter-value="' + value + '"]';
                    var input = block.querySelector(selector);
                    if (input) input.checked = true;
                });
            } catch (e) {
                // no-op: avoid breaking listing if parsing fails
            }
        }

        if (!window.__raftorDiscountFilterStabilizerDocBound) {
            window.__raftorDiscountFilterStabilizerDocBound = true;

            // Initial try after filters render.
            setTimeout(stabilizeDiscountFilterBlock, 650);

            // Re-check after appending more products.
            document.addEventListener('products-loaded', function() {
                setTimeout(stabilizeDiscountFilterBlock, 50);
            });

            // Re-check on any filter-driven DOM updates (scoped).
            document.addEventListener('change', function(e) {
                if (!e.target) return;
                var root = document.getElementById('product-filters');
                if (!root || !root.contains(e.target)) return;
                if (e.target.closest && e.target.closest('.product-filter')) {
                    setTimeout(stabilizeDiscountFilterBlock, 100);
                }
            }, true);
        }

        // Observe filters DOM updates (filters/sorting re-render) and restabilize.
        // Core ProductView may replace the entire sidebar on refresh; re-bind observer when that happens.
        var filtersRoot = document.getElementById('product-filters');
        if (!filtersRoot || !window.MutationObserver) return;

        if (window.__raftorDiscountFilterObservedRoot === filtersRoot) {
            setTimeout(stabilizeDiscountFilterBlock, 0);
            return;
        }

        window.__raftorDiscountFilterObservedRoot = filtersRoot;

        try {
            if (window.__raftorDiscountFilterObserver) {
                window.__raftorDiscountFilterObserver.disconnect();
            }
        } catch (e) {
            // no-op
        }

        var timer = null;
        window.__raftorDiscountFilterObserver = new MutationObserver(function () {
            if (timer) window.clearTimeout(timer);
            timer = window.setTimeout(stabilizeDiscountFilterBlock, 150);
        });
        window.__raftorDiscountFilterObserver.observe(filtersRoot, { childList: true, subtree: true });

        setTimeout(stabilizeDiscountFilterBlock, 0);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
